import { Box, Button } from "@mui/material";
import React from "react";
import { useDispatch,useSelector } from "react-redux";
import { addFile } from "../productGroupSetupSlice";
import AttachmentIcon from "@mui/icons-material/Attachment";
import { useRef } from "react";

export default function CreateFileUpload() {
	const pgState = useSelector((store) => store.productGroupSetup);
	const {
	   files,
	} = pgState;
  const inputRef = useRef(null);
  const dispatch = useDispatch();

  function handleInputClick() {
    inputRef.current.click();
  }

  // function uploadFile(event) {
  //   for (let i = 0; i < event.target.files.length; ++i) {
  //     const file = event.target.files[i];
  //     console.log(file);
  //     dispatch(addFile(file));
  //   }
  // }

  function uploadFile(event) {
		const newFiles = [];
		
      for(let i = 0; i < event.target.files.length; ++i) {
         const file = event.target.files[i];
		 // Check if the file is already in the state
		 const isDuplicate = files.some(existingFile =>
			existingFile.name === file.name &&
			existingFile.size === file.size &&
			existingFile.lastModified === file.lastModified
		 );
		 if (!isDuplicate) {
			dispatch(addFile(file));
		 } 
      }
	  if (newFiles.length > 0) {
		newFiles.forEach((file) => dispatch(addFile(file)));
	  }	
	  // Reset the input field to ensure onChange event fires
	  event.target.value = "";
	}

  return (
    <Box>
      <input
        hidden
        type="file"
        multiple={true}
        ref={inputRef}
        onChange={uploadFile}
      />

      <Button
        startIcon={<AttachmentIcon />}
        sx={{
          bgcolor: "darkBlue.light",
          color: "white.main",
          textTransform: "none",
          fontWeight: "bold",
          "&:hover": {
            bgcolor: "darkBlue.main",
          },
          marginLeft: "calc(100% - 155px)",
        }}
        onClick={handleInputClick}
      >
        Attach File
      </Button>
    </Box>
  );
}
